import { render, staticRenderFns } from "./gocco-filter-horizontal.vue?vue&type=template&id=26767382&"
import script from "./gocco-filter-horizontal.vue?vue&type=script&lang=ts&"
export * from "./gocco-filter-horizontal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports